import { useEffect, useState } from "react";
import { useGetTablesStructureQuery, useLazyGetTableValueQuery } from "../../../api/rtk/base/slices/tablesApiSlice";
import { getValueWithMapLinks, prepareTableData } from "../../../features/dataFormatFunctions/dataFormatter";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";
import { prepareQueryArgsForTableFetch } from "../../../widgets/table/tableFeatures/tableFetchFunctions";
import { configureTableLazyState, tableStateModifyHandle, TableEvents, defineTableColumnsFromColumnsStructureObject, mergeColumns, tableColumnExtensions } from "../../../widgets/table/tableFeatures/tableFunctions";
import { getBasicTablePaginator } from "../../../widgets/table/tableFeatures/tableTemplates/tablePaginatorTemplates";
import TableWidget from "../../../widgets/table/tableWidget/TableWidget";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../../stateManagement/reducers";
import { getItemWebStorage } from "src/features/webStorageSaver";

type TableUnderMapProps = {
    mapName?: string,
    objectType: string | undefined,
    canBeFiltered?: boolean,
    filtersExpression?: string
}

export default function TableUnderMapSingleType({ mapName, objectType, canBeFiltered, filtersExpression }: TableUnderMapProps) {
    const dispatch = useDispatch()
    const [columns, setColumns] = useState<any>([])
    const [tableState, setTableState] = useState<any>(null)
    const [tableValueUrl, setTableValueUrl] = useState<string>('')
    const [paginator, setPaginator] = useState<any>({})
    const [paginatorPageInputTooltip, setPaginatorPageInputTooltip] = useState<any>('Введите номер страницы.')
    const [tableValue, setTableValue] = useState<any>([])
    const [tableLoading, setTableLoading] = useState<boolean>(true)
    const [dataCount, setDataCount] = useState<number | undefined>()
    const currentConfig = getItemWebStorage("currentConfig");
    const structureSuffix = currentConfig?.structureSuffix

    const {
        data: tablesStructure,
        isError: isErrorTableStructure,
    } = useGetTablesStructureQuery({ structureSuffix })

    const [fetchTableValue, { isError: isErrorTableValue }] = useLazyGetTableValueQuery()

    useEffect(() => {
        const paginatorTemplate = getBasicTablePaginator(paginatorPageInputTooltip, setPaginatorPageInputTooltip, tableState, setTableState, dataCount, objectType)
        setPaginator(paginatorTemplate)
    }, [dataCount, tableState, paginatorPageInputTooltip])

    useEffect(() => {
        if (tablesStructure && objectType) {
            let columnsStructure: any = tablesStructure[objectType]
            const tableValueUrl = (columnsStructure?.url)
            let columns = defineTableColumnsFromColumnsStructureObject(columnsStructure, canBeFiltered, 'highlight', true, tableValueUrl)
            if (mapName) {
                const exts = tableColumnExtensions[mapName] ?? [];
                columns = mergeColumns(columns, exts);
            }
            setTableState(configureTableLazyState({}))
            setColumns(columns)
            setTableValueUrl(tableValueUrl)
        }
    }, [tablesStructure, objectType])

    async function getTableValue(tableState: any) {
        setTableLoading(true)
        const { sortString, filterStringArray, page }: any = prepareQueryArgsForTableFetch(tableState, columns)
        const { data: tableValueResponse } = await fetchTableValue({
            tableValueUrl,
            pages: true,
            top: 100,
            order: sortString,
            filterString: filtersExpression,
            filterStringArray,
            skip: page * 100
        })
        let value = tableValueResponse?.value
        value = getValueWithMapLinks(value, objectType)
        value = prepareTableData(value, columns)
        setTableValue(value)
        let dataCount = tableValueResponse?.['@xdata.count']
        setDataCount(dataCount)
        setTableLoading(false)
    }

    useEffect(() => {
        if (tableValueUrl && columns) {
            getTableValue(tableState)
        }
    }, [tableValueUrl, tableState, columns, filtersExpression])

    const onSort = (state: any) => tableStateModifyHandle(state, TableEvents.sort, setTableState, null, false)
    const onPage = (state: any) => tableStateModifyHandle(state, TableEvents.page, setTableState, null, false)
    const onFilter = (state: any) => tableStateModifyHandle(state, TableEvents.filter, setTableState, null, false)

    useEffect(() => {
        if (isErrorTableStructure || isErrorTableValue) {
            setTableLoading(false)
        }
    }, [isErrorTableStructure, isErrorTableValue])


    useEffect(() => {
        if (isErrorTableValue || isErrorTableStructure) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error" }))
        }
    }, [isErrorTableValue, isErrorTableStructure])

    return (
        <div className="table-widget-with-toast half-size">
            <LoaderWrapper isLoading={tableLoading} >
                <TableWidget
                    tableValue={tableValue}
                    tableState={tableState}
                    columns={columns}
                    dataCount={dataCount}
                    paginatorTemplate={paginator}
                    pageSize={100}
                    onPage={onPage}
                    onSort={onSort}
                    onFilter={onFilter}
                    canBeFiltered={canBeFiltered}
                    isLazy={true}
                />
            </LoaderWrapper>
        </div>
    )
}

